import { useTranslation } from 'react-i18next'
import { KeyType } from 'enums'
import { Button, PageHeader, Duration } from 'components'
import LockConfigs from './lockConfigs'
import './styles.scss'

export default function StoreDetailsScreen(props) {
  const {
    usingOrgSettings,
    keyExpirationInterval,
    storeData,
    onProvision: provision,
    onEdit,
    canEditStore,
    canProvision,
  } = props
  const { store, region, address, connectHubs } = storeData
  const { t } = useTranslation(null, { useSuspense: false })

  return (
    <div className='store-details-comp page'>
      <PageHeader title={store?.name}>
        {canEditStore && <Button flat icon='edit' onClick={onEdit}/>}
      </PageHeader>
      <div className='content'>
        <div className='row'>

          <div className='col'>
            <h3>{t('storeDetails.contact')}</h3>
            <p className='subtitle'>{t('storeDetails.contactName')}</p>
            <p>{store?.contactName || ''}</p>
            <p className='subtitle'>{t('storeDetails.contactEmail')}</p>
            <p>{store?.contactEmail || ''}</p>
            <p className='subtitle'>{t('storeDetails.contactPhone')}</p>
            <p>{store?.contactPhone || ''}</p>
          </div>

          <div className='col'>
            <h3>{t('resource.key', {count: 100})}</h3>
            {usingOrgSettings && (
              <h4 className="explanation">{t('storeDetails.usingOrgSettings')}</h4>
            )}
            {keyExpirationInterval ? (
              <>
                <p className='subtitle'>{t('organizationDetails.keyExpirationInterval')}</p>
                {<Duration milliseconds={keyExpirationInterval * 1000} />}
              </>
            ) : (
              <>
                <p className='subtitle'>{t('organizationDetails.keyExpiration')}</p>
                <p>{t('organizationDetails.noExpiration')}</p>
              </>
            )}
            <p className='subtitle'>{t('storeDetails.keyAllowedTypes')}</p>
            <ul>
              {store?.allowedKeyTypes?.map(kt => (
                <li key={kt}>{t(`key.type.${KeyType(kt)}`)}</li>
              ))}
            </ul>
          </div>

          <div className='col'>
            <h3>{t('storeDetails.other')}</h3>
            <p className='subtitle'>{t('storeDetails.branchCode')}</p>
            <p>{store?.branchCode || ''}</p>
            <p className='subtitle'>{t('storeDetails.region')}</p>
            <p>{region?.name || ''}</p>
            <p className='subtitle'>{t('storeDetails.timeZone')}</p>
            <p>{store?.timeZone || ''}</p>
            <p></p>
          </div>
        </div>

        <div className='row second-row'>
          <div className='col'>
            <h3>{t('address.address')}</h3>
            <p className='subtitle'>{t('address.address')}</p>
            <p>{address?.address1}</p>
            <p>{address?.address2}</p>
            <p>{address?.address3}</p>
            <p className='subtitle'>{t('address.city')}</p>
            <p>{address?.city}</p>
            <p className='subtitle'>{t('address.state')}</p>
            <p>{address?.state}</p>
            <p className='subtitle'>{t('address.postalCode')}</p>
            <p>{address?.zip}</p>
            <p className='subtitle'>{t('address.country')}</p>
            <p>{address?.country}</p>
          </div>

          <div className='col'>
            <h3>{t('resource.meshController', {count: 100})}</h3>
            {connectHubs?.map(hub => (
              <div key={hub.id} className='col'>
                <div className='row hub-info'>
                  <div className={`indicator ${hub?.status || 'unavailable'}`}></div>
                  <p>{hub?.identifier}</p>
                  <p>{`(${hub.id})`}</p>
                </div>
                {canProvision && <Button onClick={()=>provision(hub.id)}>{t('storeDetails.startProvisionMode')}</Button>}
              </div>
            ))}
          </div>

          <LockConfigs storeID={store?.id} />

        </div>
      </div>
    </div>
  )
}
